/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {filter, Subject} from "rxjs";
import {AppEvent} from "./app-event";

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    private eventBroker = new Subject<AppEvent<any>>();

    broadcast(name: string, value?: any) {
        console.debug("broadcast [name=" + name + " , value=" + value + "]")
        this.eventBroker.next(new AppEvent(name, value));
    }

    on(eventName, callback) {
        this.eventBroker.pipe(filter((event) => event.name === eventName))
            .subscribe(callback);
    }
}
